<template lang="html">
  <v-form>
    <v-layout justify-center>
      <v-flex xs6>
        <AutocompleteComponent v-model="vm" idSuffix="1" :raiseError="raiseError"/>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import AutocompleteComponent from '@/components/busie/AutoComplete/AutocompleteComponent'
import {mapActions} from 'vuex';
export default {
  components: {
    AutocompleteComponent
  },
  data: () => ({
    vm: 'something'
  }),
  methods: {
    ...mapActions('app', ['raiseError'])
  }
}
</script>

<style lang="css" scoped>
</style>
